'use client';
import CategoryGrid, { GridType } from '@components/shared/CategoryGrid';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { memo } from 'react';
import GridItem from './_AmbassadorsGridItem';
import Section from '@repo/ui/src/components/Section';
import { Data } from '@typings/productGrid';
import searchAuthors from '@api/search/searchAuthorsFn';

interface AmbassadorsGridProps {
  title?: string;
  pluralType?: string;
  _data?: Data;
}

const AmbassadorsGrid = ({ title, pluralType, _data }: AmbassadorsGridProps) => {
  const { locale } = useCurrentUrl();
  const ambassadorFilter = { authorType: 'Ambassador' };

  const loadData = async (
    { page }: { page: number },
  ): Promise<any> => {
    return await searchAuthors({
      filters: JSON.stringify(ambassadorFilter),
      page: page.toString(),
      pageSize: '10',
      lang: locale,
    });
  };

  return (
    <Section gutterX basePadding white>
      {title && <h2 className="tra-text-web-heading-2">{title}</h2>}
      <p className="md:tw-flex md:tw-justify-end tra-text-web-body-xl tw-pr-6">
        {_data?.nbHits || 0} {pluralType || 'Ambassadors'}
      </p>
      <CategoryGrid
        _data={_data}
        loadData={loadData}
        GridItemComponent={GridItem}
        type={GridType.Ambassador}
        disableBorder
        className="tw-bg-white"
        content={{}}
        hideAddToCartButton={false}
      />
    </Section>
  );
};

export default memo(AmbassadorsGrid);